import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { MaterializeModule } from 'angular2-materialize';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthenticationService } from './service/authentication.service';
import { AutoEletricService } from './service/auto-eletric.service';
import { AutoEletricProvidedServiceService } from './service/auto-eletric-provided-service.service';
import { TxNavBarComponent } from './component/tx-nav-bar/tx-nav-bar.component';
import { TxSideNavComponent } from './component/tx-side-nav/tx-side-nav.component';
import { LayoutScopeComponent } from './component/layout-scope/layout-scope.component';
import { TechnicianService } from './service/technician.service';
import { ProvidedServiceService } from './service/provided-service.service';
import { TxLocationSelectComponent } from './component/tx-location-select/tx-location-select.component';
import { CnpjPipe } from './pipe/cnpj.pipe';
import { CpfPipe } from './pipe/cpf.pipe';
import { CepPipe } from './pipe/cep.pipe';
import { PhonePipe } from './pipe/phone.pipe';
import { AccessoryLocalService } from './service/accessory-local.service';
import { AccessoryAmountService } from './service/accessory-amount.service';
import { HttpService } from './service/http.service';
import { CustomerService } from './service/customer.service';
import { BranchService } from './service/branch.service';
import { TxAutoCompleteComponent } from './component/tx-auto-complete/tx-auto-complete.component';
import { TxFilterComponent } from './component/tx-filter/tx-filter.component';
import { EquipmentService } from './service/equipment.service';
import { EquipmentModelService } from './service/equipment-model.service';
import { TelecomProviderService } from './service/telecom-provider.service';
import { EquipmentTypeService } from './service/equipment-type.service';
import { SimCardService } from './service/sim-card.service';
import { DatePipe } from './pipe/date.pipe';
import { AccessoryService } from './service/accessory.service';
import { FileService } from './service/file.service';
import { TxMultimediaDisplayComponent } from './component/tx-multimedia-display/tx-multimedia-display.component';
import { SafeUrlPipe } from './pipe/safe-url.pipe';
import { ToastService } from './service/toast.service';
import { TxSimpleMapComponent } from './component/tx-simple-map/tx-simple-map.component';
import { AttendingTypeService } from './service/attending-type.service';
import { TxFloatButtonComponent } from './component/tx-float-button/tx-float-button.component';
import { TxAddButtonComponent } from './component/tx-add-button/tx-add-button.component';
import { TxFloatingButtonComponent } from './component/tx-floating-button/tx-floating-button.component';
import { TxAddressInputComponent } from './component/tx-address-input/tx-address-input.component';
import { AttendingResponsabilityService } from './service/attendiing-responsability.service'
import { TxButtonComponent } from './component/tx-button/tx-button.component';
import { TxDisplayComponent } from './component/tx-display/tx-display.component';
import { TxEmptyStateComponent } from './component/tx-empty-state/tx-empty-state.component';
import { TxModalComponent } from './component/tx-modal/tx-modal-component';
import { JiraIssueInfoService } from './service/jira-info-service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    MaterializeModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [
    TxNavBarComponent,
    TxAutoCompleteComponent,
    TxSideNavComponent,
    LayoutScopeComponent,
    TxLocationSelectComponent,
    CnpjPipe,
    CpfPipe,
    CepPipe,
    PhonePipe,
    TxFilterComponent,
    DatePipe,
    TxMultimediaDisplayComponent,
    SafeUrlPipe,
    TxSimpleMapComponent,
    TxFloatButtonComponent,
    TxAddButtonComponent,
    TxFloatingButtonComponent,
    TxAddressInputComponent,
    TxButtonComponent,
    TxDisplayComponent,
    TxEmptyStateComponent,
    TxModalComponent
  ],
  exports: [
    TxNavBarComponent,
    TxSideNavComponent,
    TxAutoCompleteComponent,
    LayoutScopeComponent,
    TxLocationSelectComponent,
    CepPipe,
    CnpjPipe,
    CepPipe,
    PhonePipe,
    DatePipe,
    TxFilterComponent,
    TxMultimediaDisplayComponent,
    SafeUrlPipe,
    TxSimpleMapComponent,
    TxFloatButtonComponent,
    TxAddButtonComponent,
    TxFloatingButtonComponent,
    TxAddressInputComponent,
    TxButtonComponent,
    TxDisplayComponent,
    TxEmptyStateComponent,
    TxModalComponent
  ],
  providers: [
    AuthenticationService,
    AutoEletricService,
    AutoEletricProvidedServiceService,
    TechnicianService,
    ProvidedServiceService,
    HttpService,
    CustomerService,
    BranchService,
    AccessoryLocalService,
    AccessoryAmountService,
    EquipmentService,
    EquipmentModelService,
    TelecomProviderService,
    EquipmentTypeService,
    SimCardService,
    AccessoryService,
    FileService,
    ToastService,
    AttendingTypeService,
    AttendingResponsabilityService,
    JiraIssueInfoService
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/shared.module.ts